import { chat } from "../endpoints/chat.endpoints";
import $axios from "../http/accessor";

const ChatService = {
  getSession: () => $axios.get(chat.store_session),
  sendMessage: (data: {
    content?: string;
    attachment_url?: string;
    attachment_type?: string;
  }) => $axios.post(chat.store_message, data),
  upload: (data: FormData) => $axios.post(chat.upload, data),
  markRead: (session_id: number) => $axios.post(chat.read, { session_id }),
};

export default ChatService;
